import React from "react";

import { MobileTestDetails } from "@src/features/mobileAnalytics/testDetails/MobileTestDetails";
import { ReadOnlyModeProvider } from "@src/features/publicShareLinks/context/ReadOnlyModeContext";

export const ShareMobileTestDetails = () => {
  return (
    <ReadOnlyModeProvider isReadOnly={true}>
      <MobileTestDetails />
    </ReadOnlyModeProvider>
  );
};
